import { Drawer } from '@pocketlaw/tetris';
import { SidebarMenu } from 'app/domains/common-ui';
import { useMobileNavigation } from '../../MobileNavigation';
import { Body } from '../Body';
import { Footer } from '../Footer';
import { Header } from '../Header';
export function Mobile() {
    const { isOpen } = useMobileNavigation();
    return (<Drawer open={isOpen} position="left">
      <SidebarMenu>
        <Header />
        <Body />
        <Footer />
      </SidebarMenu>
    </Drawer>);
}
